module.exports = __webpack_public_path__ + "media/yolo-3.0/user-cc21e112.png";